import { inputDescLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = values => {

  const errors = {}

  if (!values.listId) {
    errors.listId = messages.provideListId;
  } else if (isNaN(values.listId)) {
    errors.listId = messages.onlyNumericKey;
  }

  if (!values.reviewContent) {
    errors.reviewContent = messages.reviewError1;
  } else if (values?.reviewContent?.length > inputDescLimit) {
    errors.reviewContent = messages.inputDescLimitError;
  }

  if (!values.rating) {
    errors.rating = messages.reviewError2;
  }

  return errors
}

export default validate;